/* eslint-disable max-len */
import React from 'react'
import { useSelector } from 'react-redux';
import MultiSelect from '../../../../components/MultiSelect';

export default function AddAssociationTopSection({
    state,
    setstate,
    handleAddSection
    ,handleRemove,
    submitSelected,
    setsubmitSelected}) {
    
    const Association=useSelector(state=>state.Association);
    const List=useSelector(state=>state.Association.List)
    const {year,class_name}=Association.selectedDropdown
    const {common}=useSelector(state=>state.CommonData);
    const{classes,
        sections,
        academic_year}=common;
    // const sections=List?.data?.map((obj)=>({...obj,name:obj.section_name,_id:obj.section_id}))
    return (
        <div className="border border-[#D0D5DD] px-4 py-2.5 rounded">
            <div className="flex -mx-[26px]">
                <div className="w-[35%] px-[26px]">
                    <div className="w-full flex items-center">
                        <div className="flex items-center w-full">
                            <label htmlFor="ledgername" className="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Academic Year</label>
                            <input type="text" id="ledgername" className="border border-[#D0D5DD] rounded w-full px-3.5 py-1.5 text-f7 font-normal text-[#031624] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 bg-[#E6E8EA]" placeholder=" " disabled defaultValue={year?.name} />
                        </div>
                    </div>
                </div>
                <div className="w-[22%] px-[26px]">
                    <div className="w-full flex items-center">
                        <div className="flex items-center w-full">
                            <label htmlFor="ledgername" className="text-f7 font-normal text-[#031624] min-w-[50px] inline-flex">Class</label>
                            <input type="text" id="ledgername" className="border border-[#D0D5DD] rounded w-full px-3.5 py-1.5 text-f7 font-normal text-[#031624] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 bg-[#E6E8EA]" placeholder=" " disabled defaultValue={class_name.name} />
                        </div>
                    </div>
                </div>
                <div className="w-[43%] px-[26px]" data-te-dropdown-ref>
                    <div className="w-full flex items-start">
                        <label htmlFor="ledgername" className="text-f7 font-normal text-[#031624] min-w-[85px] inline-flex pt-2 section_added_show">Section(s)</label>
                        <MultiSelect 
                            dropdown={sections}
                            handleSelect={handleAddSection}
                            selected={state.association}
                            id="section_id"
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            name="section_name"
                            setState={setstate}
                            state={state}
                            type="Section"
                            handleRemove={handleRemove}
                            showErrorBorder={submitSelected&&state.association?.length===0}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
